export default __webpack_public_path__ + "static/download_android-f92487868408fd907723e68d2df20499.png";